/* global swal:false */
(function () {
  "use strict";

  angular
    .module("admin.posts.post_blocked_users", [])
    .controller("PostBlockedUsersCtrl", PostBlockedUsersCtrl);

  /** @ngInject */
  function PostBlockedUsersCtrl($stateParams, $state, PostsAdminService) {
    var vm = this;
    vm.items = [];
    vm.id = $stateParams.parentId;

    function reloadPagination() {
      vm.totalUsers = 0;
      vm.oldPage = 0;
      vm.usersPerPage = 25;
      vm.currentPage = 25;
      vm.first = true;
      vm.totalItems = 0;
      vm.pagination = {
        current: 1,
      };
    }

    reloadPagination();

    load(1);

    function load(pageNumber) {
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      } else {
        vm.first = false;
      }
      PostsAdminService.listPostBlockedUsers(vm.id, vm.oldPage, 25).then(
        function (result) {
          if (vm.totalItems === 0) {
            vm.totalItems = result.ct;
          }

          vm.items = result.results;
        }
      );
    }

    vm.pageChanged = function (newPage) {
      load(newPage);
    };

    vm.showDescription = function (item) {
      $("#myModal").modal("show");
      $("#myModal").on("shown.bs.modal", function () {
        $("#description").text(item);
      });
    };

    vm.back = function () {
      if ($stateParams.returnUrl) {
        window.location = $stateParams.returnUrl;
      } else {
        $state.go("admin.posts");
      }
    };
  }
})();
